import Alert from 'react-bootstrap/Alert';
import CardDeck from 'react-bootstrap/CardDeck';
import Container from 'react-bootstrap/Container';

import Product from './Product';


const Products = (props) => {
    if (props.products.processing) {
        return "Processing...";
    }

    const { items } = props.products;
    const products = items.map((product) => (<Product key={product.key} product={product} setBuying={props.setBuying}/>))

    return (
        <>
            {products.length > 0
                ? <Container className={'p-5'}><CardDeck>{products}</CardDeck></Container>
                : <Container>
                    <Alert variant={'danger'}>
                        Unable to find products.
                            Please email <a href={'mailto:webmaster@qmforge.net'}>webmaster@qmforge.net</a>.
                    </Alert>
                </Container>}
        </>
    );
};

export default Products;